
import React from "react";
import { Route, Routes } from "react-router-dom";
import CertificateList from "../../component/Certificate/List";


function CertificatePage() {
  return (
    <Routes>
       <Route path="/*" element={<CertificateList />} />
    </Routes>
  );
}

export default CertificatePage;
